import React from "react";
import InputContainer from "./InputContainer";

const Switch = React.forwardRef((props, ref) => {
  const {
    label,
    name,
    placeholder,
    multiline,
    rows,
    error,
    size,
    onChange,
    value,
    defaultValue,
  } = props;
  return (
    <InputContainer {...props} label={" "} error={error} size={size}>
      <div className="custom-control custom-switch switch-primary">
        <input
          className="custom-control-input form-control"
          id={`customSwitchPrimary${name}`}
          ref={ref}
          // {...props}
          name={name}
          type="checkbox"
          checked={value}
          defaultChecked={defaultValue}
        />
        <label className="custom-control-label" htmlFor={`customSwitchPrimary${name}`}>
          {label}
        </label>
      </div>
      {/*
      <input
        ref={ref}
        type="text"
        className="form-control"
        name={name}
        placeholder={placeholder}
        {...props}
      /> */}
    </InputContainer>
  );
});
export default Switch;
